import React, { useEffect } from "react";
import About_banner from './about-banner/About_banner'
import About_content from './about-content/About_content'
import Counter from './about-counter/Counter'
import Core_team from './core-team/Core_team'
import Our_objective from './our-objective/Our_objective'
import { useDispatch, useSelector } from "react-redux";
import { getAboutus, getCounter, getOurTeam, getVissionMission } from "../../features/aboutus/aboutusSlice";

const About_us = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
  const vission = useSelector((state) => state.aboutus.vission_mission);
  const our_team = useSelector((state) => state.aboutus.our_team);
  const about_as = useSelector((state) => state.aboutus.about_as);

  const count = useSelector((state) => state.aboutus.count);

  useEffect(() => {
    dispatch(getVissionMission());
    dispatch(getOurTeam());
    dispatch(getAboutus());
    dispatch(getCounter());
  }, []);


  return (
    <>
      <About_banner />

      {about_as && (< About_content data={about_as} />)}

      <Counter data={count} />
      {our_team?.length > 0 && (<Core_team data={our_team} />)}
      {vission?.length > 0 && (<Our_objective data={vission} />)}

    </>
  )
}

export default About_us